module.exports = __webpack_public_path__ + "8a5356e9/img/arrow-left-icon.785c715c.svg";